import { useState, useEffect, act } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../../i18n.js";
import { getCookie } from "../../../App.js";
import '../../../css/wallet/Token/WithdrawalToken.css';
import { domain } from "../../Links/Links.js";

function TomanWithdrawal({ theme, setWithdrawalStatus, token }) {
  const [tomanWithdrawalAmountInput, setTomanWithdrawalAmountInput] =
    useState("");
  const [tomanWithdrawalBankCardInput, setTomanWithdrawalBankCardInput] =
    useState("");

  const isFilled = tomanWithdrawalAmountInput && tomanWithdrawalBankCardInput;

  const [tomanWithdrawalButtonStatus, setTomanWithdrawalButtonStatus] =
    useState(false);

  const [outOfStockError, setOutOfStockError] = useState("");

  const navigate = useNavigate();

  const translationSession = sessionStorage.getItem("translation");
  const { t, i18n } = useTranslation();

  const [active, setActive] = useState(false);

  useEffect(() => {
    if (translationSession) {
      i18n.changeLanguage(translationSession);
    }

    setActive(true);
  }, [translationSession, i18n]);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setWithdrawalStatus(false);
            setTomanWithdrawalAmountInput("");
            setTomanWithdrawalBankCardInput("");
          }, 150);
        }}
      ></div>

      <div className={`withdrawalPopupDiv ${theme} ${active && 'active'}`}>
        <div className={`withdrawalHeader ${theme}`}>{t('Withdrawal')} {' '} {token.toUpperCase()}</div>

        <div className="withdrawalContentDiv">

          <div className="kfjjekv43">
            <div>Amount</div>
            <input
              className={`kfjjeivfd input ${theme} ${outOfStockError ? "error" : ""}`}
              onChange={(e) => {
                setTomanWithdrawalAmountInput(e.target.value);
              }}
            ></input>
            {outOfStockError && (
              <div className="input_error_div">Out of stock</div>
            )}
          </div>

          <div className="kfjjekv43">
            <div>Bank card</div>
            <input
              className={`kfjjeivfd input ${theme}`}
              onChange={(e) => {
                setTomanWithdrawalBankCardInput(e.target.value);
              }}
            ></input>
          </div>

          <button
            className={`kfecvkfde submit_button ${theme} ${isFilled ? "active" : theme}`}
            onClick={() => {
              if (isFilled) {
                setTomanWithdrawalButtonStatus(true);
                const xhr = new XMLHttpRequest();
                xhr.open(
                  "POST",
                  domain + "/toman_withdrawal_api/",
                  true,
                );
                xhr.withCredentials = true;
                xhr.onreadystatechange = () => {
                  if (xhr.readyState === 4 && xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    if (data.ok) {
                      navigate("/history");
                    } else if (data.out_of_stock) {
                      setTomanWithdrawalButtonStatus(false);
                      setOutOfStockError(data.out_of_stock);
                      setTimeout(() => {
                        setTimeout(() => {
                          setOutOfStockError("");
                        }, 300);
                      }, 3000);
                    }
                  }
                };
                const data = JSON.stringify({
                  amount: tomanWithdrawalAmountInput,
                  bank_card: tomanWithdrawalBankCardInput,
                });
                xhr.setRequestHeader("Content-Type", "application/json");
                const csrfToken = getCookie("csrf_token");
                xhr.setRequestHeader("X-CSRFToken", csrfToken);
                xhr.send(data);
              }
            }}
          >
            {tomanWithdrawalButtonStatus ? (
              <img src="/icons/loading.png" className="rotate"></img>
            ) : (
              "Submit"
            )}
          </button>
        </div>

        {outOfStockError && (
          <></>
          // <div className={`kfjjgnbvd ${outOfStockErrorAniamtion ? 'active' : ''}`}>
          //     Out of stock
          // </div>
        )}
      </div>
    </>
  );
}

export default TomanWithdrawal;
